import {
  INSTANT_TAX_CREDIT_HOW_IT_WORKS,
  type INSTANT_TAX_CREDIT_USER_ADDRESS,
  route as itcRoute,
  type RoutePath,
} from '../routes/routes';

type GetInstantTaxCreditFunnelUrlParams = {
  siteUrl: string;
  route?: Extract<RoutePath, typeof INSTANT_TAX_CREDIT_HOW_IT_WORKS | typeof INSTANT_TAX_CREDIT_USER_ADDRESS>;
  searchParams?: {
    potential_public_id?: string;
  };
};

export const getInstantTaxCreditFunnelUrl = ({
  siteUrl,
  searchParams,
  route = INSTANT_TAX_CREDIT_HOW_IT_WORKS,
}: GetInstantTaxCreditFunnelUrlParams) =>
  `${siteUrl}mon-compte/credit-impot-instantane${itcRoute(route)}${
    searchParams?.potential_public_id ? `?${new URLSearchParams(searchParams).toString()}` : ''
  }`;
